<script setup lang="ts">

defineProps<{ title?: string }>()

</script>

<template>
  <div class="ys-card">
    <div class="ys-card__header" v-if="$slots.header || title">
      <slot name="header">
        <span>{{ title }}</span>
      </slot>
    </div>
    <div class="ys-card__body">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.ys-card {
  border: 1px solid #E2E4E9;
  border-radius: 16px;
  &__header {
    padding: 10px 15px 5px;
    font-size: 12px;
    color: #868C98;
  }
  &__body {
    padding: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>